import { createTRPCClient, httpBatchLink } from "@trpc/client";
import type { AppRouter } from "../express-backend/trpc";
import { supabase } from "./supabase/supabaseClient";

export const trpc = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: `${import.meta.env.VITE_PDF_MICROSERVICE_URL}/trpc`,
      async headers() {
        const { data } = await supabase.auth.getSession();
        const token = data.session?.access_token;
        return token ? { Authorization: `Bearer ${token}` } : {};
      },
    }),
  ],
});
